import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { ICancellablePromise } from 'src/app/types/cancellable-promise';
// @ts-ignore
import { LngLat } from '!mapbox-gl';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { LayerTypeEnum } from '../sl-layer';
import { SLProject } from '../sl-project';
import { ResultsLayer } from '../virutal-layers/results-layer';


export interface MapLocation {
	center: LngLat;
	zoom: number;
	bearing: number;
	pitch: number;
}

export interface MapConfigLegacy {
	bgcolor: number;
	styleUnselResults: string;
	styleSelResults: string;

	useCheckers: boolean;
}

export interface MapConfig extends MapConfigLegacy {
	resultInput: string;
	baseMap: string;
	hillshade: boolean;
	contour: boolean;
	buildings: boolean;
	location: MapLocation;
}
export interface MapIOOptions {
	location: boolean;
	layerOrder: boolean;
	layerSettings: boolean;
	baseMap: boolean;
	ThreeD: boolean;
	selectionStyles: boolean;
	asNew?: {
		on: boolean,
		name: string,
		openAfter: boolean;
	};
}

@Injectable({
	providedIn: 'root'
})
export class MapApiService {

	constructor(private wapi: SlWapiService) { }

	LoadMapById(mapId: number | string,opts?:any): ICancellablePromise {
		const params: any = { map: '' + mapId, noscale: 1 };
    if(opts?.public === true) {
      params['as'] = 'public';
    }
		return this.wapi.Post('map/load', params, true);
	}
	LoadMap(map: ISLMap): ICancellablePromise {
		const params: any = { map: '' + map.projectId, noscale: 1 };
		return this.wapi.Post('map/load', params, true);
	}
	ReLoadMap(map: ISLMap, options: MapIOOptions): ICancellablePromise {
		const promise = this.LoadMap(map);
		promise.then((result) => {
			const newProject = new SLProject(result.project);

			if (options.ThreeD === true) {

				map.Merge3DFromProject(newProject);
			}

			if (options.baseMap === true) {
				map.MergeBaseMapFromProject(newProject);

			}
			if ((options.layerSettings === true) || (options.layerOrder === true)) {
				const sameSize = map.project.layers.length === newProject.layers.length;
				if (options.layerOrder || !sameSize) {
					if (!!map.src.RemoveAllLayers) {
						map.src.RemoveAllLayers();
						map.RemoveAllLayers();

					}
					map.src.AddLayers(map.project.layers);
				}

				for (const pLayer of map.project.layers) {
					const layer = map.GetLayerById(pLayer.plid, true);
					if (options.layerSettings === true) {
						layer.opacity = pLayer.opacity;
						layer.labelsOn = pLayer.labels.labels_on === 1;
						layer.labelAttribute = pLayer.labels.attribute;
						layer.layerOn = pLayer.layer_on === 1;
						layer.CaptureLabelState();
					}
				}
				map.src.layersView.ShowLayers(map.layers);

			}
			if (options.location === true) {
				map.MergeLocationFromProject(newProject);
			}
			if (options.selectionStyles === true) {
				map.MergeStylesFromProject(newProject);
				if (map.layers[0].type === LayerTypeEnum.Virtual_Results) {
					(map.layers[0] as ResultsLayer).Render();
				}
			}
		});
		return promise;
	}
	SaveMap(map: ISLMap, options: MapIOOptions): ICancellablePromise {
		// const project = map.project;
		const config: MapConfig | MapConfigLegacy = map.project.config;
		const params: any = { config: {} };
		for (const key in config) {
			if (config.hasOwnProperty(key)) {
				params.config[key] = config[key];
			}
		}
		if (options.baseMap === true) {
			map.DecorateBaseMap(params.config);
		}
		if (options.ThreeD === true) {
			map.Decorate3D(params.config);
		}
		if (options.location === true) {
			map.DecorateLocation(params.config);
			map.DecorateExtents(params);
		}
		if (options.selectionStyles === true) {
			map.DecorateSelStyles(params.config);
		}
		if (options.layerOrder || options.layerSettings) {
			map.DecorateLayers(params, options.layerSettings);
		}
		params.config = JSON.stringify(params.config);
		params.layer_order = options.layerOrder ? 1 : 0;
		params.layer_settings = options.layerSettings ? 1 : 0;
		params.map_id = map.projectId;
		if (!!options.asNew) {
			if (options.asNew.on === true) {
				params.save_as = JSON.stringify(options.asNew);
			}
		}
		return this.wapi.Post('map/save', params);
	}

	GetFeaturesExtent(layerId: string | number, gidsString: string): ICancellablePromise {
		return this.wapi.Post('map/navigate', {
			action: 'feature_bbox',
			layer_id: layerId,
			features: gidsString
		});
	}
	GetViews(): ICancellablePromise {
		return this.wapi.Post('map/views/list', {});
	}
	GetMine(): ICancellablePromise {
		return this.wapi.Post('map/views/get/view:mine/', {});
	}
	GetView(url: string): ICancellablePromise {

		return this.wapi.Post(url, {});
	}

}
